import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { ContactConsigneeParams } from 'src/app/Models/master';
import { SpraConsigneeData, SpraConsigneeRow } from 'src/app/Models/ops';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-consignee',
  templateUrl: './spra-consignee.component.html',
  styleUrls: ['./spra-consignee.component.css']
})
export class SpraConsigneeComponent implements OnInit {
  // contactConsigneeParams: ContactConsigneeParams;
  utility: Utility;
  consigneeList: any[] = [];
  products:any[] = [];  
  contactConsigneeParams:ContactConsigneeParams;
  spraConsigneeRow:Array<SpraConsigneeRow>;
  ProfitTag : boolean = false;
  ReviewedSpra : boolean = false;
  
  constructor(
    private _MasterService: MasterService,
    private cookieService: CookieService,
    private dialogRef: MatDialogRef<SpraConsigneeComponent>,    
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _NotificationService: NotificationService
  ) {
    this.contactConsigneeParams = new ContactConsigneeParams();
    this.utility = new Utility(this.cookieService);
    this.spraConsigneeRow = new Array<SpraConsigneeRow>();    
  }

  ngOnInit(): void {    
    if(this.data != undefined){
      this.contactConsigneeParams = this.data.contactConsigneeParams;
      this.products = this.data.products;
      this.ProfitTag = this.data.ProfitTag;
      //added by rahul yadav on 11/05/2022
      this.ReviewedSpra = this.data.ReviewedSpra;


      
    }

      this.BindConsignee();
  }

BindConsigneeProduct(){
  if(this.data != undefined){
    if(this.data.spraConsigneeData.length>0){
      this.data.spraConsigneeData.map((t:SpraConsigneeData)=> { 
        let spraConsigneeRow: SpraConsigneeRow = new SpraConsigneeRow()
        spraConsigneeRow.ConsigneeId = t.ConsigneeId;
        spraConsigneeRow.DistanceID = t.DistanceID;
        spraConsigneeRow.Location = t.Location;
        spraConsigneeRow.ServiceBy = t.ServiceBy;
        spraConsigneeRow.ASPId = t.ASPId;

        this.products.forEach(element => {
          let pd:any[] = t.ProductDetails.filter(pd=> {return pd.ProductId == element.ProductId });
          if(pd.length<=0){
          let _product:any = {ProductCode:element.ProductCode,ProductId:element.ProductId,Quantity:0}
            t.ProductDetails.push( _product)
          }
        });
        


        spraConsigneeRow.ProductDetails = t.ProductDetails;
         spraConsigneeRow.IsNewRow = true;
        this.spraConsigneeRow.push(spraConsigneeRow);
        
        if(this.data.spraConsigneeData[this.data.spraConsigneeData.length-1].ConsigneeId == spraConsigneeRow.ConsigneeId){
          let lastIndex:number=(this.spraConsigneeRow.length-1);
          this.addRow(this.spraConsigneeRow[lastIndex],lastIndex);  
        }
        // if(this.spraConsigneeRow.length<=0){
        //   this.addRow(new SpraConsigneeRow(),0);
        // }else{
        //   let lastIndex:number=this.spraConsigneeRow.length-1;
        //   this.addRow(this.spraConsigneeRow[lastIndex],lastIndex);
        // }
        this.ChangeQty();
      });  
    }else{
        this.addRow(new SpraConsigneeRow(),0);
    }
    
  }

  
    // if(this.spraConsigneeRow.length<=0){
    //   this.addRow(new SpraConsigneeRow(),0);
    // }else{
    //   let lastIndex:number=this.spraConsigneeRow.length-1;
    //   this.addRow(this.spraConsigneeRow[lastIndex],lastIndex);
    // }
    
}

  BindConsignee() {
    if (this.consigneeList.length <=0 && this.contactConsigneeParams.RefId>0) {
      this._MasterService.GetContactConsignee(this.contactConsigneeParams).subscribe((data) => {
        if (data) {
          this.consigneeList.push({ "consigneeId": 0, "address1": "-- Select --" });
          this.consigneeList = this.consigneeList.concat(data);
        }        
        this.BindConsigneeProduct();
      }, (error) => {                              //Error callback
        this.utility.Error(error);
      });
    }

  }


  
  addRow(_spraConsigneeRow: SpraConsigneeRow, index: number) {
    if (!this.ProfitTag && (index == this.spraConsigneeRow.length - 1 || index==0)) {
      if(index != 0)
        _spraConsigneeRow.IsNewRow = true;
      let NewSpraConsigneeRow:SpraConsigneeRow = new SpraConsigneeRow();
      if(this.consigneeList.length == 2){
        NewSpraConsigneeRow.ConsigneeId = this.consigneeList[1].consigneeId;
      }
      NewSpraConsigneeRow.ProductDetails = this.products.map((pm)=> ({ 
        ProductCode:pm.ProductCode,
        ProductId:pm.ProductId,
        Quantity:pm.Quantity
     }));

      this.spraConsigneeRow.push(NewSpraConsigneeRow);
      return true;
    } else {
      return false;
    }

  }

  deleteRow(index: number, _spraConsigneeRow: SpraConsigneeRow) {    
    if (this.spraConsigneeRow.length == 1) {
      return false;
    } else {
      this.spraConsigneeRow.splice(index, 1);
      this.ChangeQty();
      return true;
    }
  }


  ProductModelChange(item: SpraConsigneeRow,productId:number,index:number){
    this.addRow(item,index);
    this.BindSpraQuantity(item,productId);

  }

  BindSpraQuantity(item: SpraConsigneeRow,productId:number){
    // if(item.ProductId != undefined && productId>0){
    //   item.SpraQuantity = this.products.filter((fp)=>{ return fp.productId ==  productId})[0].quantity;
    // }  
  }


  Close() {
    if(this.Validation()){

      let _spraConsigneeDataList:Array<SpraConsigneeData> =  new Array<SpraConsigneeData>();
      this.spraConsigneeRow.filter((ft)=>{ return ft.ConsigneeId>0}).forEach((element:SpraConsigneeRow) => {
        let _spraConsigneeData:SpraConsigneeData = new SpraConsigneeData();
        _spraConsigneeData.ConsigneeId = element.ConsigneeId;
        _spraConsigneeData.DistanceID = element.DistanceID;
        _spraConsigneeData.Location = element.Location;
        _spraConsigneeData.ServiceBy = element.ServiceBy;
        _spraConsigneeData.ASPId = element.ASPId;
        _spraConsigneeData.ProductDetails = element.ProductDetails.filter((fp)=>{return this.utility.CheckNumberRequired(fp.Quantity)});
        if(_spraConsigneeData.ProductDetails.length >0){
          _spraConsigneeDataList.push(_spraConsigneeData);
        }        
      });

      this.dialogRef.close({ event: 'Close', data: {SpraConsigneeDataList:_spraConsigneeDataList,Products:this.products }});
    }
    
  }

  Validation(): boolean {
    let IsConsigneeSelected: boolean = false;
    let IsConsigneeValid: boolean = true;
    this.spraConsigneeRow.forEach((ft)=> {
      ft.ProductDetails.forEach((pd)=>{ 
      if( this.utility.CheckNumberRequired(ft.ConsigneeId)
      &&  this.utility.CheckNumberRequired(pd.Quantity)){
        IsConsigneeSelected = true;
      }      
    });

     });

    if (!IsConsigneeSelected) {
      this._NotificationService.showError("Please enter at least one consignee/Product detail.", "Consignee Detail");
      return false;
    } else if (this.products.filter((fp)=>{ return fp.RemainingQty <0 }).length >0){
      this._NotificationService.showError("Total Consinee product quantity can not be more then the SPRA product quantity.", "Consignee Detail");
      return false;
    } else if (this.products.filter((fp)=>{ return fp.RemainingQty >0 }).length >0){
      this._NotificationService.showError("Total Consinee product quantity can not be less then the SPRA product quantity.", "Consignee Detail");
      return false;
    }
    else {
      return IsConsigneeValid;
    }
  

  }

  ChangeQty(){
    this.products.forEach((pf,i)=> {
      pf.RemainingQty  = pf.SpraQuantity;
      this.spraConsigneeRow.forEach((scr)=>{
        scr.ProductDetails.forEach((pd)=>{
          if( pf.ProductId == pd.ProductId && this.utility.CheckNumberRequired(pd.Quantity)){
            pf.RemainingQty = pf.RemainingQty - pd.Quantity;
          }
        });
      });  

    
    });
    
  }

}
